import React from "react";
import { Link } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import SEO from "../common/SEO";
import AboutThree from "../component/about/AboutThree";
import CounterUpOne from "../component/counterup/CounterUpOne";
import ClientSlider from "../component/client/ClientSlider";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";

const HealthSafety = () => {
  const isTabletOrAbove = () => {
    return window.innerWidth >= 768; 
  };

  const detailsService = {
    title: "Sustainability",
    description:
      "At UCWF, energy efficiency is a key pillar of our sustainability-driven facilities management approach. We focus on implementing advanced technologies and strategic solutions to reduce energy consumption, lower operational costs, and minimize environmental impact. <br /> <br />  Energy efficiency is not only an eco-friendly choice but also a cost-effective strategy that enhances performance and extends asset lifespan. Partner with UCWF for sustainable, energy-efficient solutions that reduce costs and optimize your facilities.  ",
    image: "/images/banner/innerbanner/sustainabilityinnerbanner.jpg",
    process: {
      steps: [
        {
          id: 1,
          icon: "/images/health-safety/comprensive.png",
          title: "Comprehensive Training Programs",
          paragraph:
            "At UCWF, we understand that knowledge is essential for maintaining a safe working environment. To ensure the highest safety standards, all employees undergo specialized training programs tailored to their specific roles. These programs cover workplace safety protocols, hazard identification, emergency response procedures, and the proper handling of tools and materials. To stay ahead of evolving best practices, our team regularly participates in updates and refresher courses, ensuring they are always equipped with the latest safety guidelines and industry standards.",
        },
        {
          id: 2,
          icon: "/images/health-safety/adherence.png",
          title: "Adherence to Safety Standards",
          paragraph:
            "In addition to adhering to the regulations set by the UAE Municipality and other local authorities, UCWF fully complies with both national and international health and safety laws. We take pride in ensuring our policies not only meet but exceed these standards, providing our employees with a secure and protected work environment. Our team is equipped with comprehensive safety guidelines and personal protective equipment (PPE), reinforcing our commitment to their well-being. ",
        },
        {
          id: 3,
          icon: "/images/health-safety/employeehealth.png",
          title: " Employee Health Monitoring",
          paragraph:
            "We prioritize the physical and mental well-being of our employees. UCWF conducts regular health checks to ensure the fitness of all personnel, particularly those working in high-risk environments. In addition to monitoring physical health, we promote mental health awareness and offer resources to support employees facing stress or other challenges, ensuring their overall health is nurtured.",
        },
        {
          id: 4,
          icon: "/images/health-safety/commitment.png",
          title: "Commitment to a Safe Work Environment",
          paragraph:
            "At UCWF, we are dedicated to maintaining a safe and secure workplace. Our facilities are equipped with clear signage, proper lighting, and well-maintained equipment to ensure a hazard-free environment. Routine audits and inspections are conducted to proactively identify and address potential risks, ensuring swift corrective actions are taken when necessary.",
        },
        {
          id: 5,
          icon: "/images/health-safety/emergency.png",
          title: "Emergency Preparedness and Response",
          paragraph:
            "Preparedness is a cornerstone of our safety strategy. UCWF has developed comprehensive emergency response plans to address potential crises, including fires, medical emergencies, and environmental threats. Our employees are regularly trained through drills, ensuring they are well-equipped to respond to any situation with confidence and efficiency.",
        },
        {
          id: 6,
          icon: "/images/health-safety/commithealth.png",
          title: "Our Commitment to Health and Safety",
          paragraph:
            "At UCWF, we go beyond simply complying with regulations—we genuinely care about the well-being of our team. By prioritizing both physical and mental health, we ensure our employees feel valued and protected. This dedication enables them to perform at their best, contributing to a safe, positive, and productive workplace.",
        },
      ],
      thumb1: "/images/sustainability-thumb1.jpg",
      thumb2: "/images/sustainability-thumb2.jpg",
    },
  };

  return (
    <>
      <SEO title="Health Safety" />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne
          subtitle=""
          title="Occupational Health & Safety"
          page="Health-safety"
        />
        <div
          className="section  spalsh-why-choose"
          id="splash-why-choose"
          style={{ padding: "110px 0px 40px" }}
        >
          <div className="container">
            <div className="row">
              {detailsService.process.steps.map((portfolio) => (
                <div className="col-xl-6 col-lg-6" key={portfolio.id}>
                  <div
                    className={`project-grid `}
                    style={{ border: "1px solid #562b7a" }}
                  >
                    <div className="thumbnail">
                      <Link to={portfolio.link}></Link>
                    </div>
                    <div
                      className="content"
                      style={isTabletOrAbove() ? { minHeight: "380px" } : {}}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          className="icon"
                          style={{ paddingRight: "8px", paddingBottom: "10px" }}
                        >
                          <img
                            src={process.env.PUBLIC_URL + portfolio.icon}
                            alt="Thumb"
                          />
                        </div>
                        <h4 className="title">{portfolio.title}</h4>
                      </div>

                      <span className="subtitle">
                        <>
                          <div>{portfolio.paragraph}</div>
                          <div style={{ paddingTop: "10px" }}>
                            {portfolio.paragraph2}
                          </div>
                        </>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <CounterUpOne />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />
        <AboutThree />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default HealthSafety;
